import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=72ff40ee&scoped=true"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"
import style0 from "./Part.vue?vue&type=style&index=0&id=72ff40ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff40ee",
  null
  
)

export default component.exports